import React, { useState, useEffect } from "react";
import { Input, Col, Row, notification, Form, Button, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import RequestHandler from "../../util/RequestHandler";

const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};

const FirmClassUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(props.userId);
  const [firstName, setFirstName] = useState(props.firstName);
  const [lastName, setLastName] = useState(props.lastName);
  const [email, setEmail] = useState(props.email);
  const [erpSalesCode, setErpSalesCode] = useState(props.erpSalesCode);
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber);
  const [isTosAuthorize, setIsTosAuthorize] = useState(props.isTosAuthorize);
  const [tosAuthorizeId, setTosAuthorizeId] = useState(props.tosAuthorizeId);
  const [tosAuthorizeLimit, setTosAuthorizeLimit] = useState(
    props.tosAuthorizeLimit
  );
  const [password, setPassword] = useState("");
  const [form] = Form.useForm();
  const [posErpSalesCode, setPosErpSalesCode] = useState(props.posErpSalesCode);
  const [salesCodeGroup, setSalesCodeGroup] = useState(props.salesCodeGroup);
  const [isSalesCodeGroupAdmin, setIsSalesCodeGroupAdmin] = useState(props.isSalesCodeGroupAdmin);

  useEffect(() => {
    setUserId(props.userId);
    setFirstName(props.firstName);
    setLastName(props.lastName);
    setEmail(props.email);
    setTosAuthorizeId(props.tosAuthorizeId);
    setErpSalesCode(props.erpSalesCode);
    setIsTosAuthorize(props.isTosAuthorize);
    setPhoneNumber("+90" + props.phoneNumber);
    setTosAuthorizeLimit(props.tosAuthorizeLimit);
    setPosErpSalesCode(props.posErpSalesCode);
    setSalesCodeGroup(props.salesCodeGroup);
    setIsSalesCodeGroupAdmin(props.isSalesCodeGroupAdmin);



    form.setFieldsValue({
      isB2bAdmin: props.isB2bAdmin,
      isB2bFirmAdmin: props.isB2bFirmAdmin,
      isB2bCancel: props.isB2bCancel,
      isSalesCodeGroupAdmin: props.isSalesCodeGroupAdmin,
    });
  }, [
    props.userId,
    props.firstName,
    props.lastName,
    props.email,
    props.tosAuthorizeId,
    props.isTosAuthorize,
    props.tosAuthorizeLimit,
    props.erpSalesCode,
    props.phoneNumber,
    props.posErpSalesCode,
    props.salesCodeGroup,
    props.isSalesCodeGroupAdmin,
  ]);

  const onChangeFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const onChangeLastName = (e) => {
    setLastName(e.target.value);
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const onChangeErpSalesCode = (e) => {
    setErpSalesCode(e.target.value);
  };

  const onChangePosErpSalesCode = (e) => {
    setPosErpSalesCode(e.target.value);
  };

  const onChangeSalesCodeGroup = (e) => {
    setSalesCodeGroup(e.target.value);
  };

  const onChangePhoneNumber = (e) => {
    setPhoneNumber(e);
  };

  const onFinishUpdate = (values) => {
    setLoading(true);
    RequestHandler.put(
      `/Auth`,
      {
        id: userId,
        lastName: values.LastName,
        firstName: values.FirstName,
        salesCode: values.ErpSalesCode,
        email: values.Email,
        phoneNumber: values.PhoneNumber,
        password: values.Password,
        isB2bAdmin: values.isB2bAdmin,
        isB2bCancel: values.isB2bCancel,
        isB2bFirmAdmin: values.isB2bFirmAdmin,
        posSalesCode: values.ErpSalesCodeForPosReport,
        salesCodeGroup: values.SalesCodeGroup,
        isSalesCodeGroupAdmin: values.isSalesCodeGroupAdmin,
      },
      false,
      { rawResponse: true }
    )
      .then((res) => {
        if (res.status == 200) {
          if (
            values.TosAuthorizeLimit !== undefined &&
            values.TosAuthorizeLimit !== 0 &&
            values.TosAuthorizeLimit !== null
          ) {
            RequestHandler.post(
              `/TosAuthorize/UpdateTosLimit`,
              {
                tosAuthorizeLimit: values.TosAuthorizeLimit,
                id: tosAuthorizeId,
              },
              false,
              { rawResponse: true }
            ).then((res) => {
              if (res.status == 200) {
                openNotificationWithIconUpdate("success");
                setTimeout(
                  function () {
                    props.sendDataForUpdate("success");
                    setLoading(false);
                  }.bind(this),
                  2000
                );
              } else {
                setLoading(false);
              }
            });
          } else {
            openNotificationWithIconUpdate("success");
            setTimeout(
              function () {
                props.sendDataForUpdate("success");
                setLoading(false);
              }.bind(this),
              2000
            );
          }
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  const openNotificationWithIconUpdate = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  return (
    <div>
      {isDesktopOrLaptop && (
        <>
          <Form
            {...layout}
            name="basic"
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdate}
            onFinishFailed={onFinishFailedUpdate}
            fields={[
              { name: "FirstName", value: firstName },
              { name: "LastName", value: lastName },
              { name: "PhoneNumber", value: phoneNumber },
              { name: "Email", value: email },
              { name: "Password", value: password },
              { name: "ErpSalesCode", value: erpSalesCode },
              { name: "TosAuthorizeLimit", value: tosAuthorizeLimit },
              { name: "ErpSalesCodeForPosReport", value: posErpSalesCode },
              { name: "SalesCodeGroup", value: salesCodeGroup }

              // { name: "isB2bAdmin", value: props.isB2bAdmin },
              // { name: "isB2bFirmAdmin", value: props.isB2bFirmAdmin },
              // { name: "isB2bCancel", value: props.isB2bCancel },
            ]}
          >
            <Row>
              <Col span={5}></Col>
              <Col span={15}>
                <Form.Item
                  label="Ad"
                  name="FirstName"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Ad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input name={firstName} onChange={onChangeFirstName} />
                </Form.Item>
                <Form.Item
                  label="Soyad"
                  name="LastName"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Soyad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input name={lastName} onChange={onChangeLastName} />
                </Form.Item>
                <Form.Item label="Şifre" name="Password">
                  <Input.Password
                    autoComplete="new-password"
                    name={password}
                    onChange={onChangePassword}
                  />
                </Form.Item>
                <Form.Item
                  label="E-Posta Adresi"
                  name="Email"
                  validateTrigger="onSubmit"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen E-Posta Adresi alanını boş bırakmayın.",
                    },
                    { 
                      type: "email", 
                      message: "Lütfen geçerli bir e-posta adresi giriniz." 
                    },
                  ]}
                >
                  <Input name={email} onChange={onChangeEmail} />
                </Form.Item>
                <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                  <Input name={erpSalesCode} onChange={onChangeErpSalesCode} />
                </Form.Item>

                <Form.Item label="Satıcı Kodu (Pos)" name="ErpSalesCodeForPosReport">
                  <Input name={posErpSalesCode} onChange={onChangePosErpSalesCode}/>
                </Form.Item>

                <Form.Item label="Satıcı Grubu" name="SalesCodeGroup">
                  <Input name={salesCodeGroup} onChange={onChangeSalesCodeGroup} />
                </Form.Item>


                <Form.Item
                  label="Telefon Numarası"
                  name="PhoneNumber"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                    {
                      required: true,
                      message:
                        "Lütfen Telefon Numarası alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <PhoneInput
                    name={phoneNumber}
                    onChange={onChangePhoneNumber}
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
                {isTosAuthorize ? (
                  <Form.Item label="Tos limit" name="TosAuthorizeLimit">
                    <Input
                      name={tosAuthorizeLimit}
                      type="number"
                      onChange={(text) => {
                        setTosAuthorizeLimit(text.target.value);
                      }}
                      value={tosAuthorizeLimit}
                    />
                  </Form.Item>
                ) : null}

                <Form.Item
                  label="B2B Yöneticisi"
                  name="isB2bAdmin"
                  valuePropName="checked"
                  style={{
                    visibility: props.modules.includes(8)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <Switch
                    checked={props.isB2bAdmin}
                    onChange={(checked) => {
                      form.setFieldsValue({ isB2bAdmin: checked });
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="B2B Bayi Yöneticisi"
                  name="isB2bFirmAdmin"
                  valuePropName="checked"
                  style={{
                    visibility: props.modules.includes(8)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <Switch />
                </Form.Item>
                <Form.Item
                  label="B2B İşlem İptali"
                  name="isB2bCancel"
                  valuePropName="checked"
                  style={{
                    visibility: props.modules.includes(8)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <Switch />
                </Form.Item>


                <Form.Item
                  label="Satıcı Grup Yöneticisi"
                  name="isSalesCodeGroupAdmin"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={9}></Col>
              <Col span={7}>
                <Form.Item style={{ marginLeft: "250%" }}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={2}></Col>
            </Row>
          </Form>
        </>
      )}
      {isTabletOrMobileDevice && (
        <>
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdate}
            onFinishFailed={onFinishFailedUpdate}
            fields={[
              { name: "FirstName", value: firstName },
              { name: "LastName", value: lastName },
              { name: "PhoneNumber", value: phoneNumber },
              { name: "Email", value: email },
              { name: "ErpSalesCode", value: erpSalesCode },
            ]}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  label="Ad"
                  name="FirstName"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Ad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input name={firstName} onChange={onChangeFirstName} />
                </Form.Item>
                <Form.Item
                  label="Soyad"
                  name="LastName"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Soyad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input name={lastName} onChange={onChangeLastName} />
                </Form.Item>
                <Form.Item
                  label="E-Posta Adresi"
                  name="Email"
                  validateTrigger="onSubmit"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen E-Posta Adresi alanını boş bırakmayın.",
                    },
                    { 
                      type: "email", 
                      message: "Lütfen geçerli bir e-posta adresi giriniz." 
                    },
                  ]}
                >
                  <Input name={email} onChange={onChangeEmail} />
                </Form.Item>
                <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                  <Input name={erpSalesCode} onChange={onChangeErpSalesCode} />
                </Form.Item>


                <Form.Item
                  label="Telefon Numarası"
                  name="PhoneNumber"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                    {
                      required: true,
                      message:
                        "Lütfen Telefon Numarası alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <PhoneInput
                    name={phoneNumber}
                    onChange={onChangePhoneNumber}
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
              </Col>
              <Col span={10}></Col>
              <Col span={8}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </Row>
          </Form>
        </>
      )}
    </div>
  );
};
export default FirmClassUpdate;
